const TOP_AFTER_REOPEN = 0;
const TOP = 1;
const FIXED = 2;
const DIRECTION_BOTTOM = 'bottom';
const DIRECTION_TOP = 'top';
const DIRECTIONS = [DIRECTION_TOP, DIRECTION_BOTTOM];
const selectionFeedbackOptions = ['top-after-reopen', 'top', 'fixed'];
export {
  TOP_AFTER_REOPEN,
  TOP,
  FIXED,
  selectionFeedbackOptions,
  DIRECTIONS,
  DIRECTION_TOP,
  DIRECTION_BOTTOM,
};
